import PropTypes from 'prop-types';
var nullishPropType = PropTypes.oneOf([null, undefined]);
export { nullishPropType };